enum ScheduleBlockEditorState {
    NONE = "NONE",
    EDITING = "EDITING",
    CREATING = "CREATING",
    VIEWING = "VIEWING"
}

export default ScheduleBlockEditorState;
